<template lang="html">
  <div class="card project-card h-100">
    <router-link :to="{ name: 'project', params: { slug: project.slug } }">
      <div class="image-container">
        <img
          :src="
            'https://db.sephendevos.com/storage/uploads/' +
            project.image[0].path +
            '?modified=' +
            project._modified
          "
        />
      </div>
      <div class="card-body">
        <h5 class="card-title">{{ project.name }}</h5>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ProjectCard",
  props: {
    project: Object,
  },
};
</script>

<style lang="css" scoped>
.card-title {
  /*color: #c4007c;*/
}
.project-card {
  border: none;
  background-color: transparent;
}
.project-card img {
  border-radius: 3px;
}
.project-card .card-body {
  padding: 5px;
}
.image-container {
  position: relative;
  width: 100%;
  padding-top: 75%; /* 4:3 aspect ratio */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
</style>
